import React, { useMemo } from "react";
import { CompassData } from "./compass.data";
import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
import { useAttributeValueComponents, useRenderers } from "@me8eon/renderers";
import { SimpleWidget } from "@me8eon/simple_widget";
import { ThemedIcon } from "@me8eon/icons"
import { useCommonComponents } from "@me8eon/components";
import { decodeHTML } from "@me8eon/string_utils";
import { getFormattedDateTime } from "@me8eon/time";

export const CompassDisplay: DisplayData<CompassData> =
    ({ rootId, id, data }: DisplayDataProps<CompassData>) => {
        const { ClipHeight } = useCommonComponents();
        const { H1WithIconAndUrl, Markdown, Url } = useRenderers();
        const { Text, DataLayout } = useAttributeValueComponents();
        const newRootId = `${rootId}.${id}`;
        const cardTitle = decodeHTML(data.title);
        const cardDescription = data.description ? data.description?.replace(/<[^>]+>/g, ' ').replace(/\n/g, ' ') : data.description;
        const issueSummaryAndUrl = useMemo(() =>
            ({ url: data.url, title: cardTitle, icon: () => <ThemedIcon name="compass" shouldChangeColor={false} /> }), [data.url, cardTitle]);

        return <DataLayout rootId={newRootId} className='jira-data' layout={[1, 1, 4, 1]}>
            <H1WithIconAndUrl rootId={newRootId} attribute={translateLabelForData('name')} value={issueSummaryAndUrl} />
            {cardDescription !== 'undefined' ? <ClipHeight maxHeight='2rem' force={false}>
                <Markdown rootId={id} attribute={translateLabelForData('data.description')} value={cardDescription} />
            </ClipHeight> : <></>}
            <Text rootId={id} attribute={translateLabelForData('source')} value="Compass" />
            <Text rootId={id} attribute={translateLabelForData('type')} value={data.contentType} />
            <Text rootId={id} attribute={translateLabelForData('createdOn')} value={getFormattedDateTime(new Date(data.createDate), 'Y-m-d')} />
            <Text rootId={id} attribute={translateLabelForData('lastUpdated')} value={getFormattedDateTime(new Date(data.lastModifiedDate), 'Y-m-d')} />
            <Url rootId={id} attribute={translateLabelForData('url')} value={data.url} />
        </DataLayout>;
    };

export const SimpleCompassOneLineDisplay: DisplayData<CompassData> =
    ({ data, listItemClicked }: DisplayDataProps<CompassData>) => {
        const { SearchListItem } = useRenderers();

        const issueSummaryAndUrl = useMemo(() =>
        ({
            title: data.title,
            icon: () => <ThemedIcon name="compass" shouldChangeColor={false} />,
            onClick: () => { listItemClicked && listItemClicked(data.title) }
        }), [data.title]);


        return (
            <SearchListItem key={data.title} rootId={data.title} attribute={translateLabelForData('name')} value={issueSummaryAndUrl} />
        )
    }
export const SimpleCompassWidget: DisplayDataWidget<CompassData> =
    SimpleWidget(
        ['name', 'description'],
        ['title', 'description'],
        ['id']);

